import { useMemo } from 'react'

export const SelfRegisterCard = ({ children, apFormSelfRegister }) => {
  let textColor = useMemo(() => apFormSelfRegister.form.colorText || 'black', [apFormSelfRegister.form])

  return (
    <div className="card my-2" style={{ color: textColor }}>
      <div className="card-body">
        {children}
      </div>
    </div>
  )
}
